import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onMounted, ref } from 'vue';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { useRoute } from 'vue-router';
import { workspacesApi } from '@/workspaces/workspaces';
import UsersInWorkspace from '@/features/settings/views/UsersInWorkspace.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditWorkspaceUsers',
  setup(__props) {

const route = useRoute();
const workspaceId = computed(() => <string>route.params.id);
const workspace = ref<WorkspaceViewModel>();

const workspaceLoaded = computed(() => !!workspace.value);

onMounted(async () => {
  workspace.value = await workspacesApi.getById(workspaceId.value);
});

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!

  return (!workspaceLoaded.value)
    ? (_openBlock(), _createBlock(_component_n_loading_spinner, {
        key: 0,
        style: {"margin":"4rem auto"}
      }))
    : (_openBlock(), _createBlock(UsersInWorkspace, {
        key: 1,
        "provided-workspace": workspace.value
      }, null, 8, ["provided-workspace"]))
}
}

})